import { defineComponent as _defineComponent } from 'vue'
import {
  computed,
  onMounted,
  ref,
  useRoute,
  watch,
  useRouter,
  useContext,
  useStore,
} from '@nuxtjs/composition-api';
import { curriculumNames } from '~/data/curriculum_names';
import { State } from '@/store';

interface Tab {
  name: string;
  slug?: string;
  active?: boolean;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'TabList',
  props: {
    tabs: null,
    tabname: null,
    collapsed: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  tabs: Tab[];
  tabname?: string;
  collapsed?: boolean;
};

const { $mzAnalyticsApi } = useContext();
const route = useRoute();
const router = useRouter();

const $store = useStore<State>();
const resource = computed(() => $store.getters.resource);

const activeTab = ref(props.collapsed ? -1 : 0);

const checkHash = () => {
  // If the URL has a hash, open relevant tab on page load and route change
  if (route.value.hash && props.tabs.length > 0) {
    // Compare the hash with the tabs slug field
    const index = props.tabs.map(tab => tab.slug).indexOf(route.value.hash.substring(1));
    if (index !== -1) {
      // Exists in the tabs array? Show that tab
      activeTab.value = index;
    }
  }
};
const changeTab = (index: number, slug = '') => {
  // When a tab is clicked, show the tab contents by its index
  activeTab.value = index;

  // Also add the slug as a URL hash eg. #tab-2
  if (index === 3) {
    const pagePath = route.value.path;
    const pathSegments = pagePath.split('/').filter(Boolean);
    let pageType = pathSegments.length > 1 ? pathSegments[1] : pathSegments[0]; // Adjust based on URL structure
    pageType = pageType.replace(/[\s-]+/g, '_').toLowerCase();

    let productAreas = '';
    if (pageType === 'teaching_resource') {
      pageType = 'resource';
      productAreas = 'resources';
    } else if (pageType === 'unit_plan') {
      productAreas = 'unit_plan';
    } else if (pageType === 'teaching_resource_pack') {
      pageType = 'pack';
      productAreas = 'pack';
    } else if (pageType === 'widget') {
      productAreas = 'widget';
    }
    const analyticsName = `${pageType}.help`;
    $mzAnalyticsApi({
      event: 'click',
      name: analyticsName,
      productArea: productAreas,
      entityType: pageType,
      entityId: resource.value.id,
    });
  }
  const hash = slug ? '#' + slug : '';
  router.push({ hash });
};
const getTabNameforCurriculum = (tabname: string) => {
  return curriculumNames[tabname];
};
onMounted(() => {
  checkHash();
});
watch(route, () => {
  checkHash();
});

return { __sfc: true,$mzAnalyticsApi, route, router, props, $store, resource, activeTab, checkHash, changeTab, getTabNameforCurriculum }
}

})